
import test from './test';
import alertDag from './alert';
import sendMqtt from './sendMqtt';
import init from './init';
import echartsGlobal from './echarts';
import openTopoConfig from './openTopoConfig';

import { jsToken } from '../../../types/config';
/**
  * @typedef {Object} funcModule
  * @property {string} name 函数消息模块名称
  * @property {string} desc 描述信息
  * @property {string} key 唯一标识
  * @property {string} value 消息名，用于监听
  * @property {Function} func 函数模块
  */

/**
 * @type {funcModule}
 */
let $functions = new Proxy({}, {
    get(target, propKey) {
        if (typeof propKey !== 'string') return {};
        /**@type {Array<any>} */
        let tokenArr = propKey.split('__');
        let token = tokenArr[0], key = tokenArr[1]
        if (token !== jsToken) {
            return {};
        }
        return Reflect.get(target, key);
    },
    set(target, property, value) {
        if(typeof value.func == 'function' && value.name){
            target[property] = value
        }
        return true;
    },
})

$functions.test = {
    name: 'test',
    desc: '测试发送mqtt数据',
    key: 'test',
    value: 'test',
    func: test
};
$functions.alert = {
    name: 'alert',
    desc: '弹窗',
    key: 'alert',
    value: 'alert',
    func: alertDag
};

$functions.sendMqtt = {
    name: 'sendMQTT',
    desc: '发送mqtt消息',
    key: 'sendMqtt',
    value: 'sendMqtt',
    func: sendMqtt
};

$functions.initJs = {
    name: 'initJs',
    desc: `
    · 初始化模块 \n 
    · 添加组件额外属性 {online} 标识设备在线离线状态 \n 
    · 添加了全局函数 {$alert}弹窗，{reload}刷新页面 \n
    · 添加组件额外属性 {controllerMode}, 在数据中设置了controllerMode属性的会自动绑定控制模式，\n通过判断CtrlMode的值来确定控制模式,使用CtrlKey属性来控制手自动模式
    
    `,
    key: 'initJs',
    value: 'initJs',
    func: init
};

$functions.echartsGlobal = {
    name: 'echartsGlobal',
    desc: `
    · 全局注册echarts,只需要选择对应的统计模块的id即可,该函数只适用于单数据集，不适合多数据集对比 \n
    · 需要在数据中绑定统计模块id到 statisticsID 属性上 \n
    · 添加了全局函数周统计 {createChartsWeek} \n
    · 添加了全局函数月统计 {createChartsMonth} \n
    · 添加了全局函数年统计 {createChartsYear} \n
    `,
    key: 'echartsGlobal',
    value: 'echartsGlobal',
    func: echartsGlobal
};

$functions.openTopoConfig = {
    name: 'openTopoConfig',
    desc: `打开配置文件\n
    · 可直接打开保存在云端的配置，在参数栏中填写保存在云端的key即可打开\n
    · 也可以直接将配置文本复制到参数栏中\n
    · 可以直接添加网络配置文件地址，以http或https开头的网络地址`,
    key: 'openTopoConfig',
    value: 'openTopoConfig',
    func: openTopoConfig
}

globalThis.$functions = $functions;

export default $functions;